var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.33,0s-8.14,8.18-2,14.33c.33,.33-2.33,1.33-2.33,1.33v2l1.67,1s-.67,16.67-14,18c0,0-7.33,6.33,3,9,0,0,9,17-12,19.67l-.34,4.67s-13.66-1.67-13.33,8.67c0,0-2,7,8.33,9,0,0-3.67,9,6,8.33,0,0,12.67,8.33,10.33,30.33,0,0-10.67-4.33-2.33,6.33,0,0,1.67,6-.33,9.67,0,0,1.33,6.67,7.67,7.67v2s-3.67,1,2,4.67c0,0,7.33,14-9.67,20.67,0,0-6.67,.67-2.33,5l-4,.33v8.33H0V0H92.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.67,0s8.14,8.18,2,14.33c-.33,.33,2.33,1.33,2.33,1.33v2l-1.67,1s.67,16.67,14,18c0,0,7.33,6.33-3,9,0,0-9,17,12,19.67l.33,4.67s13.67-1.67,13.33,8.67c0,0,2,7-8.33,9,0,0,3.67,9-6,8.33,0,0-12.67,8.33-10.33,30.33,0,0,10.67-4.33,2.33,6.33,0,0-1.67,6,.33,9.67,0,0-1.33,6.67-7.67,7.67v2s3.67,1-2,4.67c0,0-7.33,14,9.67,20.67,0,0,6.67,.67,2.33,5l4,.33v8.33h68.68V0H97.67Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b8d3dac19f8b1e1aef053c1101de7231.svg";
export { ForwardRef as ReactComponent };